import Component from '../abstracts/Component';

export default class SizeSelectorComponent extends Component {

  get COMPONENTNAME() {
    return 'SizeSelectorComponent';
  }

  get SELECTORS() {
    return {
      size: '[data-size] input',
      sizeRadioBox: '[data-size]',
    };
  }

  get CLASSES() {
    return {
      selected: '--selected',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.sizes = this.$component.querySelectorAll(this.SELECTORS.size);
  }

  // put classes on selected size
  selectSize(size) {
    let prevSize = this.$component.querySelector(this.CLASSES.selected);
    if (prevSize) {
      prevSize.classList.remove(this.CLASSES.selected);
    }
    size.closest(this.SELECTORS.sizeRadioBox).classList.add(this.CLASSES.selected);
  }

  bindEvents() {
    let ctx = this;
    // pdp CTA
    if (this.sizes.length) {
      this.sizes.forEach(size => {
        size.addEventListener('click', () => {
          // put size
          ctx.selectSize(size);
          // if not available launch notify me event
          if (size.dataset.unavailable === 'true') {
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.notifyme, { productCode: this.$component.dataset.productCode });
            ctx.$emit(ctx.$customEvents.CHANGE_RETURN_STEPS.disabledConfirm, { size:size });
          } else {
            // if available i want to hide the notifyme form
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.notifymeclose, { productCode: this.$component.dataset.productCode });
            ctx.$emit(ctx.$customEvents.CHANGE_RETURN_STEPS.enableConfirm, { size:size });
          }
          // general event
          ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.sizechanged,
            {
              productCode: size.getAttribute('data-product-code'),
              baseProductCode: this.$component.getAttribute('data-product-code')
            });
          // reset error
          // find error box
          let sizeErrorBox = document.querySelector('[data-sizes-error=prod_'+this.$component.dataset.productCode+']');
          if (sizeErrorBox && !sizeErrorBox.classList.contains('--hidden')) {
            sizeErrorBox.classList.add('--hidden');
            sizeErrorBox.innerHTML = '';
          }
        });
      });
    }

    // Size not selected event
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizerequired, (e) => {
      // find error box
      let sizeErrorBox = document.querySelector('[data-sizes-error=prod_'+e.payload.getAttribute('data-product-code')+']');
      // put error
      if (sizeErrorBox && sizeErrorBox.classList.contains('--hidden')) {
        sizeErrorBox.classList.remove('--hidden');
        sizeErrorBox.innerHTML = e.payload.attributes['data-notification'].nodeValue;
      }
    });

    // if size has been selected
    this.$on(this.$customEvents.PRODUCT_EVENTS.addtocart, ({event, payload}) => {
       let btn = payload.button;
       // find error box
       let sizeErrorBox = document.querySelector('[data-sizes-error=prod_'+btn.getAttribute('data-product-code')+']');
       // remove error
       if (sizeErrorBox && !sizeErrorBox.classList.contains('--hidden')) {
         sizeErrorBox.classList.add('--hidden');
         sizeErrorBox.innerHTML = '';
       }
    });

  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
  }
}
